import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";

// Componentes
import PrivateRoute from './components/PrivateRoute';

// Styles
import "./App.css";

// Loading component
import Loading from "./pages/Loading.jsx";

// react-toastify
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// Lazy load pages
const Inicio = lazy(() => import("./pages/Inicio"));
const Federacion = lazy(() => import("./pages/Federacion.jsx"));
const InicioAdmin = lazy(() => import("./pages/admin/Inicioadmin.jsx"));
const LoginAdmin = lazy(() => import("./pages/admin/Loginadmin.jsx"));

function App() {
  return (
    <>
      <ToastContainer
        autoClose={3000}              
        hideProgressBar={false}       
        newestOnTop={false}        
        closeOnClick             
        rtl={false}                  
        pauseOnFocusLoss  
        draggable 
        pauseOnHover 
      />
      
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route path="/" element={<Inicio />} />
          <Route path="/federacion/:id/*" element={<Federacion />} />
          <Route path="/loginadmin" element={<LoginAdmin />} />
          <Route
            path="/inicioadmin"
            element={<PrivateRoute element={<InicioAdmin />} />}
          />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
